const MODULE = {

  state: {
    bearerToken: localStorage.getItem('user-token') || '',
    authStatus: false,
    currentlySettingUpEventSocket: false,
    userInfo: null
  },

  mutations: {
    setBearerToken: (state, token) => {
      localStorage.setItem('user-token', token)
      state.bearerToken = token
    },

    removeBearerToken: (state) => {
      localStorage.removeItem('user-token')
      state.bearerToken = localStorage.getItem('user-token') || ''
    },

    setAuthStatusTrue: (state) => {
      state.authStatus = true
    },

    setEventSocketSetupProgress: (state, progress) => {
      if (progress === 'start') {
        state.currentlySettingUpEventSocket = true
      } else if (progress === 'finish') {
        state.currentlySettingUpEventSocket = false
      }
    },

    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
    },

    setOrganizationInfo: (state, organizationInfo) => {
      state.organizationInfo = organizationInfo
    }
  },

  actions: {
    authRequest: async (context, loginData) => {
      const endpoint = '/id/auth?username=test@fyelabs.com'
      const url = process.env.VUE_APP_API_BASE + endpoint
      const response = await fetch(url, {
        method: 'POST',
        // injects the bearer token on any fetch
        headers: new Headers({
          Authorization: 'bf502aa0268ac7a156ac9c4e90957413'
        }),
        credentials: 'include',
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
      })

      const data = await response.json()
      console.log(data)

      // if (data.success) {
      //   context.commit('setBearerToken', data.authorization)
      //   context.commit('setAuthStatusTrue')
      //   await context.dispatch('setupState')
      // }

      // return data
    },

    setupState: async (context) => {
      console.log('setupState')

      // setup user and organization info
      // (we check for both because organization's value depends on user info)
      if (context.state.userInfo === null ||
        context.rootState.organization.clientOrganizationInfo === null) {
        await context.dispatch('requestUserInfo')
        // await context.dispatch('requestClientOrganizationInfo')
      }

      // setup challenge info
      // await context.dispatch('requestAllChallenges')

      // if (context.rootState.challenge.currentlyViewedChallenge !== null) {
      //   // setup stuff that depends on the current challenge
      //   if (context.rootState.canvas.socket === null) {
      //     await context.dispatch('canvas/setupSocket')
      //   }

      //   if (context.rootState.event.socket === null) {
      //     await context.dispatch('setupEventSocket')
      //   }

      //   if (context.rootState.event.chatLog.length === 0) {
      //     await context.dispatch('requestChatHistory')
      //   }

      //   if (context.rootState.event.notificationLog.length === 0) {
      //     await context.dispatch('requestNotificationHistory')
      //   }
      // }
    },

    authorizeWebsocket: async ({ rootState, dispatch }) => {
      const response = await dispatch('authorizedFetch', {
        method: 'get',
        endpoint: '/api/v1/ws/auth',
        queryParams: {
          challenge: rootState.challenge.currentlyViewedChallenge.uuid
        }
      }, { root: true })

      return response.token
    },

    requestUserInfo: async (context) => {
      var endpoint = '/api/v1/user/current'

      const userInfo = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: endpoint
      })

      userInfo.avatar = await context.dispatch('getAvatarFromUserName', userInfo.account.name)

      console.log('LOGGED IN', userInfo)

      context.commit('setUserInfo', userInfo)
    },

    requestUserIsLoggedIn: async (context) => {
      const response = await fetch(`${process.env.VUE_APP_API_BASE}/api/v1/user/current`, {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
      })

      if (response.status === 200) {
        return true
      }

      return false
    },

    authLogout: async (context) => {
      // context.commit('removeBearerToken')
      await context.dispatch('teardownState') // TODO there was nothing else here but we probably need to tell the server that the user has logged out
    },

    teardownState: async (context) => {
      // user and user's organization state teardown
      context.commit('setUserInfo', null)
      context.commit('setClientOrganizationInfo', null)

      // challenges teardown
      context.commit('setActiveChallenges', [])
      context.commit('setArchivedChallenges', [])

      // sockets teardown
      context.commit('canvas/removeCanvasSocket')
      context.commit('setEventSocket', null)

      // event log teardown
      context.commit('setChatLog', [])
      context.commit('setNotificationLog', [])
    },

    requestPasswordResetLink: async (context, email) => {
      // TODO request a password reset

      // return response
    },

    requestPasswordReset: async (context, { token, password }) => {
      // TODO process a password reset

      // return response
    }
  }
}

export default MODULE
